import { render, staticRenderFns } from "./GenericAwardList.vue?vue&type=template&id=5bcfdab6&scoped=true"
import script from "./GenericAwardList.vue?vue&type=script&lang=js"
export * from "./GenericAwardList.vue?vue&type=script&lang=js"
import style0 from "./GenericAwardList.vue?vue&type=style&index=0&id=5bcfdab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcfdab6",
  null
  
)

export default component.exports